module.exports = __webpack_public_path__ + "img/GLOBAL_PROCESSED_MEATS.0d362678.png";